<template>
  <div
    v-if="sortedStatuses.length"
    class="offer-accreditation-badges"
    data-qa="offer-accreditation-badges">
    <sPopover
      v-for="accreditationStatus in sortedStatuses"
      :key="accreditationStatus.groupId"
      placement="bottom"
      trigger="hover">
      <div
        slot="reference"
        @click.stop="openGroup(accreditationStatus.groupId)">
        <sChip
          :background="accreditationStatusColor[accreditationStatus.status]"
          class="offer-accreditation-badges__chip"
          color="var(--color-black)"
          data-qa="accreditation-status">
          {{ $t(`groupOfAccreditation.status.${accreditationStatus.status}`) }}
        </sChip>
      </div>
      <div
        class="py-4 px-4"
        style="max-width: 280px;">
        {{ accreditationStatus.groupTitle }}
      </div>
    </sPopover>
  </div>
</template>
<script>
import { accreditationStatusColor, sortByStatusPriority } from 'helpers/accreditationStatusColor'

export default {
  name: 'offerAccreditationBadges',
  data() {
    return {
      accreditationStatusColor
    }
  },
  props: {
    statuses: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sortedStatuses() {
      const uniqueByGroup = [...new Map(this.statuses.map(item => [item.groupId, item])).values()]
      return sortByStatusPriority(uniqueByGroup)
    }
  },
  methods: {
    openGroup(groupId) {
      const routeData = this.$router.resolve({
        name: 'groupOfAccreditationsItem',
        params: { id: groupId, org: this.$route.params.org }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.offer-accreditation-badges {
  display: flex;
  flex-wrap: wrap;
  overflow-x: auto;
  gap: 4px;
  &__chip {
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.offer-accreditation-badge-tooltip {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 105px;
}
</style>
